import FileUpload from "../components/FileUpload/FileUpload";
import ChatWindow from "../components/Chat/ChatWindow";


export default function Dashboard({ activeSession, setSessions, setActiveSession, onOpenSubscription }) {
  return (
    <div className="flex-1 flex flex-col">

      {!activeSession ? (
        <div className="flex-1 flex items-center justify-center">
          <FileUpload 
            setSessions={setSessions}
            setActiveSession={setActiveSession}
            onOpenSubscription={onOpenSubscription}
          />
        </div>
      ) : (
        <ChatWindow
          session={activeSession}
          setActiveSession={setActiveSession}
          setSessions={setSessions}
          onOpenSubscription={onOpenSubscription}
        />
      )}

    </div>
  );
}